module.exports = __webpack_public_path__ + "static/media/background.f579092a.jpg";